/* eslint-disable @typescript-eslint/no-floating-promises */
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Languages } from 'lucide-react'

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { cn } from '@/lib/utils'

// Define correctamente el tipo de las props que recibe el componente
interface LanguageSelectorProps {
  className?: string
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({ className }) => {
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState('en') // Inicialmente 'en'

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language') ?? 'en_US'
    const currentLanguage = storedLanguage.startsWith('es') ? 'es' : 'en'
    setLanguage(currentLanguage)
  }, [i18n.language])

  const changeLanguage = (value: string): void => {
    const newLanguage = value === 'en' ? 'en_US' : 'es_ES'
    i18n.changeLanguage(newLanguage)
    setLanguage(value)
    localStorage.setItem('language', newLanguage)
    // navigate('/')
  }

  return (
    <>
      <Select onValueChange={changeLanguage} value={language}>
        <SelectTrigger className={cn('w-[100px] text-primary', className)}>
          <Languages className='mr-2' size={20} />
          <SelectValue placeholder={language.toUpperCase()} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value='en'>EN</SelectItem>
          <SelectItem value='es'>ES</SelectItem>
        </SelectContent>
      </Select>
    </>
  )
}
